export class SubscriptionNotification {

    static init() {
        SubscriptionNotification.handleShow();
        //
        SubscriptionNotification.handleSubscribe();
        SubscriptionNotification.handleClose()
    }

    static handleShow() {
        var $ = jQuery;

        if (!SubscriptionNotification.canShow()) {
            return;
        }

        setTimeout(function () {
            $('#vit-subscription-notification').addClass('show');
        }, 0);
    }

    static handleSubscribe() {
        var $ = jQuery;

        $('.js-subscribe-subscription-notification').on('click', function () {
            $('#vit-subscription-notification').removeClass('show');
            //
            window.localStorage.setItem(vosveteit.subscription_notification_cookie_name, SubscriptionNotification.getTimestamp());
            // Open link
            var url = $(this).attr('data-url');
            //
            window.open(url, '_blank').focus();
        })
    }

    static handleClose() {
        var $ = jQuery;
        //
        $('.js-close-subscription-notification').on('click', function () {
            $('#vit-subscription-notification').removeClass('show');
            //
            window.localStorage.setItem(vosveteit.subscription_notification_cookie_name, SubscriptionNotification.getTimestamp());
        })
    }

    static canShow() {
        console.log("Show");
        //
        var value = window.localStorage.getItem(vosveteit.subscription_notification_cookie_name);
        var timestamp = Date.now() / 1000;

        if (!value) {
            return true;
        }

        // has some value
        if (value < timestamp) {
            return true;
        } else {
            return false;
        }
    }

    static getTimestamp() {
        // Show every 10 days
        return Date.now() / 1000 + 3600 * 24 * 10;
    }
}